import {
	SHOW_TOAST,
	HIDE_TOAST,
} from '../types';

let toastId = 0;

export default {
	namespaced: true,

	state: {
		list: [],
		config: {
			position: 'top-right',
		},
	},

	mutations: {
		[SHOW_TOAST](state, toast, config) {
			state.config = {
				...state.config,
				...config,
			};

			state.list = [
				...state.list,
				{
					id: toast.id,
					title: toast.title,
					content: toast.content,
					header: toast.header,
					type: toast.type,
					isShow: true,
				},
			];
		},

		[HIDE_TOAST](state, id) {
			state.list = state.list.map((toast) => {
				return toast.id === id
					? { ...toast, isShow: false }
					: toast;
			});
		},
	},

	actions: {
		showToast({ commit }, data, config) {
			const { onClose } = data;
			const toast = {
				id: toastId++,
				...data,
			};

			commit(SHOW_TOAST, toast, config);

			if (data.onClose) {
				setTimeout(() => {
					onClose();
				}, data.timeout || 3000);
			}
		},

		hideToast({ commit }, id) {
			commit(HIDE_TOAST, id);
		},
	},
};
